import { Component, OnInit } from '@angular/core';
import {
  RESOURCE_ADMIN_TABS,
  ResourceAccessService,
  ResourceAdminTab
} from '../../../Services/resource-access.service';

/**
 * Bereich „Verwaltung“: Reiter „Team & Mitarbeiter“ und „Skills & Kategorien“ über den
 * bestehenden Seiten (Kind-Routen). Sichtbar sind nur Reiter mit passendem Recht; bei
 * nur einem erlaubten Bereich entfällt die Reiterleiste. Direktaufrufe sichert der
 * ResourceManageGuard je Kind-Route ab.
 */
@Component({
  selector: 'app-resource-administration',
  templateUrl: './resource-administration.component.html',
  styleUrls: ['./resource-administration.component.css']
})
export class ResourceAdministrationComponent implements OnInit {
  tabs: ResourceAdminTab[] = [];

  constructor(private accessApi: ResourceAccessService) { }

  ngOnInit(): void {
    this.accessApi.getMine().subscribe({
      next: access => this.tabs = RESOURCE_ADMIN_TABS.filter(t => access[t.flag]),
      error: () => this.tabs = []
    });
  }
}
